function getCorrectlyAnsweredMarkup({ correctAnswerText }) {
  return `<p class="reimagine-quiz-answer"><i class="fa fa-check" aria-hidden="true"></i>You answered correctly: ${correctAnswerText}</p>`;
}

export { getCorrectlyAnsweredMarkup };